<template>
  <div class="wrapper">
    <div class="bg-page" :style="bgPage"></div>
    <div class="panel">
      <div class="body-panel-login">
        <b-form>
          <img
            class="img-fluid mx-auto d-block"
            src="@/assets/logo-indecx.png"
            alt=""
          />
          <p class="recover-password">
            {{ $t('forgotPassword.form.description') }}
          </p>
          <b-form-group>
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-input-group-text slot="prepend">
                <i style="margin-top: 3px;" class="far fa-envelope"></i>
              </b-input-group-text>
              <b-input
                id="email"
                v-model="form.email"
                type="email"
                required
                :placeholder="$t('forgotPassword.form.emailInput')"
                autofocus
              ></b-input>
            </b-input-group>
          </b-form-group>
          <b-form-group>
            <b-button
              type="button"
              @click="validateData()"
              class="btn-block"
              variant="primary"
              :disabled="loading"
              >{{ $t('forgotPassword.form.submitButton') }}</b-button
            >
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '../../../../services/api';
import backgroundImage1 from '../../../../assets/1.png';
import backgroundImage2 from '../../../../assets/2.png';
import backgroundImage3 from '../../../../assets/3.png';
import backgroundImage4 from '../../../../assets/4.png';
import backgroundImage5 from '../../../../assets/5.png';
import backgroundImage6 from '../../../../assets/6.png';
import backgroundImage7 from '../../../../assets/7.png';

export default {
  name: 'ForgotPassword',
  data: () => ({
    show: true,
    loading: false,
    form: {
      email: null,
    },
    bgPage: {
      background: null,
      backgroundRepeat: null,
      backgroundSize: null,
      backgroundPosition: null,
    },
    securityToken: null,
    securityCookie: null,
  }),

  computed: {
    ...mapState('authentication', ['user']),
  },

  methods: {
    async validateData() {
      this.loading = true;

      if (!this.form.email) {
        this.makeToast(
          this.$t('login.tooltips.emailValidation.description'),
          this.$t('login.tooltips.emailValidation.title'),
        );
      } else {
        try {
          api.defaults.withCredentials = true;
          const requestToken = await api.get('/getcsrftoken', {
            withCredentials: true,
          });
          this.securityToken = requestToken.data.csrfToken;
          api.defaults.headers.common['X-CSRF-TOKEN'] = this.securityToken;
          await api.post(
            '/forgot-password',
            {
              email: this.form.email,
              _csrf: this.securityToken,
            },
            {
              withCredentials: true,
            },
          );
          this.$router.push('/validate-code');
        } catch (error) {
          this.$router.push('/login');
        }
      }

      this.loading = false;
    },

    makeToast(message, title, append = false) {
      this.toastCount += 1;

      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: 'danger',
      });
    },
  },

  mounted() {
    const imgs = [
      backgroundImage1,
      backgroundImage2,
      backgroundImage3,
      backgroundImage4,
      backgroundImage5,
      backgroundImage6,
      backgroundImage7,
    ];

    this.bgPage.background = `url('${imgs[Math.floor(Math.random() * 7)]}')`;
    this.bgPage.minHeight = '100vh';
    this.bgPage.minWidth = '100vw';
    this.bgPage.backgroundRepeat = 'no-repeat';
    this.bgPage.backgroundSize = 'cover';
    this.bgPage.backgroundAttachment = 'fixed';
    this.bgPage.backgroundPosition = 'center';
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';
.recover-password {
  text-align: center;
  font-size: 0.9em;
}

.wrapper {
  @extend %center;

  .bg-page {
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    transform: scale(1);
    opacity: 0.6;
    z-index: -1;
    transition: all 0.2s linear;
    animation: zoomOut 0.4s;
  }

  @keyframes zoomOut {
    from {
      transform: scale(1.3);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 0.6;
    }
  }

  .panel {
    width: 90%;
    max-width: 420px;

    border-radius: 5px;
    display: flex;
    flex-direction: column;
    @include bg-color(rgba(255, 255, 255, 0.8));
    @media screen and (min-width: 576px) {
      width: 100%;
    }

    .body-panel-login {
      @extend %double-padding-left,
        %double-padding-right,
        %double-padding-top,
        %double-padding-bottom;

      form {
        @extend %double-padding-top, %double-padding-bottom;
        .img-fluid {
          width: 50%;
          margin-bottom: 30px;
        }
        .input-group-text {
          border: none;
          @include bg-color($white);
          border-top-left-radius: 30px;
          border-bottom-left-radius: 30px;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-right: none;
        }
        .form-control {
          box-shadow: none;
          border: none;
          border-top-right-radius: 30px;
          border-bottom-right-radius: 30px;
          @include bg-color($white);
          text-indent: 0;
          padding: 0;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-left: none;
        }
      }
      button {
        border-radius: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/forgot-password/index.vue